// extracted by mini-css-extract-plugin
export default {"contentWrapperTopPadding":"6em","mediumGrey":"#777","ProjectScreenHeaderHeight":"60px","defaultFontFamily":"\"Roboto\",Arial,sans-serif","nowrap":"styles_nowrap__VX3I7"};